/**
 * The Timato mark, from the same file the favicon and the PWA manifest use, so the tab, the installed icon and
 * the page can never drift apart. It is already in the service worker's precache as `apple-touch-icon`, so
 * drawing it here costs no extra request.
 *
 * The clock face is opaque white with the dial drawn on it, which is why it needs no theme variant: it reads
 * the same on the light canvas and on the dark marketing bands.
 */
export function Logo({ size = 26 }: { size?: number }) {
  return (
    <img
      src="/icons/icon-192x192.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      decoding="async"
      className="shrink-0"
    />
  );
}
